import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ListForecastMonth } from '../../core/models/forecast.models';
import { ListForecastWeek } from '../../core/models/forecast.models';
import { ListForecastYear } from '../../core/models/forecast.models';

export type SortColumn = keyof ListForecastMonth | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = {
	asc: 'desc',
	desc: '',
	'': 'asc',
};

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()',
	},
})
export class NgbdOrdersSortableHeader {
	@Input() sortable: SortColumn = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}

////////////////////// Week

export type SortColumnWeek = keyof ListForecastWeek | '';
export type SortDirectionWeek = 'asc' | 'desc' | '';
const rotateWeek: { [key: string]: SortDirection } = {
	asc: 'desc',
	desc: '',
	'': 'asc',
};

export interface SortEventWeek {
	column: SortColumnWeek;
	direction: SortDirectionWeek;
}

@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()',
	},
})
export class NgbdOrdersSortableHeaderWeek {
	@Input() sortable: SortColumnWeek = '';
	@Input() direction: SortDirectionWeek = '';
	@Output() sort = new EventEmitter<SortEventWeek>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}

////////////////////// Year

export type SortColumnYear = keyof ListForecastYear | '';
export type SortDirectionYear = 'asc' | 'desc' | '';
const rotateYear: { [key: string]: SortDirection } = {
	asc: 'desc',
	desc: '',
	'': 'asc',
};

export interface SortEventYear {
	column: SortColumnYear;
	direction: SortDirectionYear;
}

@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()',
	},
})
export class NgbdOrdersSortableHeaderYear {
	@Input() sortable: SortColumnYear = '';
	@Input() direction: SortDirectionYear = '';
	@Output() sort = new EventEmitter<SortEventYear>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}
